/**
 * Created by DejanK on 8/3/2017.
 *
 * rbHasUppercase
 *
 * Validates that input has lowercase character
 */

export default rbHasLowercase;

function rbHasLowercase() {
  return {
    require: 'ngModel',
    link: (s, e, attrs, ngModelCtrl)=>{
      ngModelCtrl.$validators.rbHasLowercase = (modelValue, viewValue)=>{
        const pattern = /(?=\S*?[a-z])/;
        return pattern.test(modelValue || viewValue);
      }
    }
  }
}
